<template>
  <div class="detail-container">
    <DForm
      :model="formModel"
      :formItems="formItems"
      label-width="140px"
      ref="formRef"
    >
    </DForm>
    <div class="submit-button">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { configApi } from "../indexServe";

export default {
  props: {
    formData: Object,
  },
  data() {
    return {
      formModel: {
        appName: "",
        packageName: "",
        status: null,
      },
      formItems: [
        {
          label: "应用名称",
          prop: "appName",
          required: true,
          type: "Input",
          // props: {
          //   options: [], // 动态赋值
          //   clearable: false,
          // },
          span: 24,
        },
        {
          label: "应用包名",
          prop: "packageName",
          required: true,
          type: "Input",
          span: 24,
        },
        {
          label: "是否开启CPS投放",
          prop: "status",
          required: true,
          type: "Switch",
          span: 24,
          props: {
            activeValue: 1,
            inactiveValue: 0,
          },
        },
      ],
    };
  },
  created() {
    Object.assign(this.formModel, this.formData);
  },
  methods: {
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.handleSave();
        }
      });
    },
    handleSave() {
      let data = this.formModel;
      // 更新
      let urlName = this.formData.id ? "update" : "create";
      if (this.formData.id) {
        data.id = this.formData.id;
      }
      configApi(urlName, data).then((res) => {
        if (res.code === 0) {
          this.handleSuccess("保存成功");
        }
      });
    },
    handleSuccess(message) {
      this.$message.success(message);
      this.$emit("success");
    },
  },
};
</script>

<style scoped lang="scss">
.submit-button {
  text-align: center;
}
</style>
